import axios from 'axios';
import { $BASE } from '../base';

export const $HTTPDEMO = axios.create({
  baseURL: $BASE + `/demos/`,
  headers: {
    'Content-Type': 'application/json'
  }
})

$HTTPDEMO.interceptors.request.use(
  request => requestHandler(request)
)
$HTTPDEMO.interceptors.response.use(
  function (response) { return response; },
  function (error) {
    // handle error
    if (error.response) {
      console.warn('Invalid token in HTTPDEMO, maybe probably');
      console.log(error.response);
      if (process.env.NODE_ENV != 'development') {
        delete localStorage.token;
        window.location.href = "/";
      } else {
        alert("ERROR, Production version would have errored out to login....");
      }
    }
  });
export const requestHandler = (request) => {
  if (true) {
    request.headers['Authorization'] = 'Bearer ' + localStorage.token
  }
  return request
}
